import {
  Component,
  ChangeDetectorRef,
  Inject,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoadingService } from './services/loading.service';
import { DOCUMENT, ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  public isLoading$: Subscription = new Subscription();
  public isLoaded: boolean = false;
  private hasScrolledToTop: boolean = false;

  constructor(
    public loadingService: LoadingService,
    private cd: ChangeDetectorRef,
    @Inject(DOCUMENT) private _document: Document,
    private readonly viewport: ViewportScroller
  ) {}

  readonly showScroll$: Observable<boolean> = fromEvent(
    this._document,
    'scroll'
  ).pipe(map(() => this.viewport.getScrollPosition()?.[1] > 0));

  ngOnInit() {
    this.showScroll$.subscribe((showScrollPoition: boolean) => {
      // console.log('showScrollPoition is:', showScrollPoition);
      if (showScrollPoition && !this.hasScrolledToTop) {
        this.viewport.scrollToPosition([0, 0]);
        this.hasScrolledToTop = true;
      }
    });
    this.isLoading$ = this.loadingService.isLoading.subscribe((value) => {
      this.isLoaded = value;
      this.cd.detectChanges();
    });
  }

  ngOnDestroy() {
    this.isLoading$.unsubscribe();
  }
}
